import {
  useFocusRange,
  usePnlCategoriesForCustomer,
} from "../../../utils/customHooks/genericHooks";
import PnlChartColumns from "./PnlSummaryChartContent/PnlChartColumns/PnlChartColumns";
import { useHiddenCategoriesForOtherProcessesPnlChart } from "./pnlSummaryChartUtils";

const PnlSummaryLoaderSkeleton = ({ isSubordinateProcessesOnly = false }) => {
  const allCategoriesSorted = usePnlCategoriesForCustomer();
  const focusRange = useFocusRange();
  const hiddenCategoriesFOrOtherProcessesPnlChart =
    useHiddenCategoriesForOtherProcessesPnlChart();

  return (
    <PnlChartColumns
      isLoading={true}
      timeRange={focusRange}
      {...{
        pnlSectionsDisplay: allCategoriesSorted
          .filter(({ category }) =>
            isSubordinateProcessesOnly
              ? !hiddenCategoriesFOrOtherProcessesPnlChart.includes(category)
              : true
          )
          .map(({ label }) => ({
            title: label,
            time: null,
            count: null,
            percent: null,
            bars: [],
          })),
      }}
    />
  );
};

export default PnlSummaryLoaderSkeleton;
